import {
  TextBlockElementClass,
  TextInputElementClass,
  MultiLineTextInputElementClass,
  PhoneNumberInputElementClass,
  YesNoInputElementClass,
  DateInputElementClass,
  DropdownElementClass,
  SsnInputElementClass,
  EmailInputElementClass,
  AddressInputElementClass,
  CurrencyInputElementClass,
  DateTimeInputElementClass,
  TimeInputElementClass,
  RatingInputElementClass,
  SignatureInputElementClass,
  SignatureDateInputElementClass,
  UrlInputElementClass,
  DividerInputElementClass,
  CheckboxInputElementClass,
  TableInputElementClass,
  DocumentTemplateElement,
} from 'types/documentTemplateElement';

export const buildDocumentTemplateElement = (
  elementType: string,
): DocumentTemplateElement | undefined => {
  elementType = elementType.replace(' ', '');

  switch (elementType) {
    case 'TextBlock':
      return new TextBlockElementClass({
        id: `element-${Date.now()}`,
        elementType: 'TextBlock',
        properties: {
          adminOnly: false,
          supervisorIds: [],
          content: '',
        },
      });
    case 'TextInput':
      return new TextInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'TextInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: '',
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'MultiLineTextInput':
      return new MultiLineTextInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'MultiLineTextInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: '',
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'PhoneNumberInput':
      return new PhoneNumberInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'PhoneNumberInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: '',
          phoneNumber: '',
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'YesNoInput':
      return new YesNoInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'YesNoInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'DateInput':
      return new DateInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'DateInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: 'Placeholder',
          allowPastDates: false,
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'Dropdown':
      return new DropdownElementClass({
        id: `element-${Date.now()}`,
        elementType: 'Dropdown',
        properties: {
          label: '',
          isMulti: false,
          required: false,
          options: [],
          showLabel: true,
          adminOnly: false,
          supervisorIds: [],
          horizontal: false,
        },
      });
    case 'SsnInput':
      return new SsnInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'SsnInput',
        properties: {
          label: 'Label',
          required: false,
          showLabel: true,
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'EmailInput':
      return new EmailInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'EmailInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: '',
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'AddressInput':
      return new AddressInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'AddressInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: '',
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'CurrencyInput':
      return new CurrencyInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'CurrencyInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: '',
          currencySymbol: '$',
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'DateTimeInput':
      return new DateTimeInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'DateTimeInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: 'Placeholder',
          allowPastDates: false,
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'TimeInput':
      return new TimeInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'TimeInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: '',
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'RatingInput':
      return new RatingInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'RatingInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          maxRating: 5,
          initialRating: 0,
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'SignatureInput':
      return new SignatureInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'SignatureInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'SignatureDateInput':
      return new SignatureDateInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'SignatureDateInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          adminOnly: false,
          showLabelDate: false,
          dateLabel: '',
          dateValue: '',
          supervisorIds: [],
          allowPastDates: true,
        },
      });
    case 'UrlInput':
      return new UrlInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'UrlInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          placeholder: '',
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'DividerInput':
      return new DividerInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'DividerInput',
        properties: {},
      });
    case 'CheckboxInput':
      return new CheckboxInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'CheckboxInput',
        properties: {
          label: '',
          required: false,
          showLabel: true,
          value: false,
          adminOnly: false,
          supervisorIds: [],
        },
      });
    case 'TableInput':
      return new TableInputElementClass({
        id: `element-${Date.now()}`,
        elementType: 'TableInput',
        properties: {
          label: '',
          rows: 2,
          columns: 2,
          showLabel: true,
          data: [
            ['', ''],
            ['', ''],
          ],
          adminOnly: false,
          supervisorIds: [],
        },
      });
    default:
      return undefined;
  }
};
